import React from 'react'
import { Margin } from '../../Margin'
import { CustomFieldWrapper, Span, FieldItem, Point } from '../style'

export const CustomField = ({ field, title, description, count, weight }) => {
    return (
        <CustomFieldWrapper>
            <FieldItem>
                {field}
                <Margin left='.5em' display='inline'>
                    {title} {count}{description ? '.' : ''} <Span>{description}</Span>
                </Margin>
            </FieldItem>
            <Point>
                <Span>{weight}</Span>
            </Point>
        </CustomFieldWrapper>
    )
}
